// extracted by mini-css-extract-plugin
export var courses = "courses-module--courses--gPosu";